import { render } from "./EditChannelPage.vue?vue&type=template&id=e5712422"
import script from "./EditChannelPage.vue?vue&type=script&lang=js"
export * from "./EditChannelPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__